import { Col, Divider, Row, Space } from 'antd';
import React, { memo } from 'react';

import Box from '../../components/Box';
import Text from '../../components/Text';
import { formatCurrencyToCompanyLocale } from '../../utils/numbers';
import BoundsIndicator from './BoundsIndicator';
import { GUTTER, STYLES } from './constants';
import RateItem from './RateItem';

const RateSection = memo(
  ({
    title,
    mainRate,
    mainBoundsKey,
    components,
    componentConfig,
    fieldsToCheck,
    getBounds,
    t,
    countryCode,
  }) => (
    <Box noShadow style={STYLES.cardBody} padding="0px">
      <Space direction="vertical" size="middle" style={STYLES.fullWidth}>
        <div>
          <Text size="lg" variant="h5" renderAs="div" style={STYLES.sectionHeader}>
            {title}
          </Text>
          <Row align="middle" gutter={GUTTER.rate}>
            <Col>
              <Text size="xl" variant="strong">
                {formatCurrencyToCompanyLocale(mainRate || 0, undefined, undefined, countryCode)}
              </Text>
            </Col>
            <Col>
              {fieldsToCheck.includes(mainBoundsKey) && (
                <BoundsIndicator
                  value={mainRate}
                  bounds={getBounds(mainBoundsKey)}
                  t={t}
                  countryCode={countryCode}
                />
              )}
            </Col>
          </Row>
        </div>

        {Object.keys(components).length > 0 && (
          <>
            <Divider style={{ margin: 0 }} />
            <Space direction="vertical" size="small" style={STYLES.fullWidth}>
              {componentConfig.map(
                ({ key, translationKey, boundsKey }) =>
                  components[key] !== undefined && (
                    <RateItem
                      key={key}
                      label={t(translationKey)}
                      value={components[key]}
                      boundsKey={boundsKey}
                      fieldsToCheck={fieldsToCheck}
                      getBounds={getBounds}
                      t={t}
                      countryCode={countryCode}
                    />
                  ),
              )}
            </Space>
          </>
        )}
      </Space>
    </Box>
  ),
);

export default RateSection;
